import React, { useContext } from 'react';
import AppContext from 'context/Context';

const TicketsFilterTabs = ({ filterTab, setFilterTab, counts = {}, isMobile = false }) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const { pendientes = 0, enProgreso = 0, cerrados = 0 } = counts;

  const tabs = [
    { id: 'pendientes', label: 'Pendientes', count: pendientes },
    { id: 'en_progreso', label: 'En Progreso', count: enProgreso },
    { id: 'resueltos', label: 'Resueltos las Ultimas 24h', count: cerrados, title: 'Resueltos en las últimas 24h' }
  ];

  return (
    <div
      className={`d-inline-flex align-items-center p-1 rounded-3 shadow-none flex-nowrap ${isMobile ? 'w-100' : ''}`}
      style={{
        backgroundColor: isDark ? '#16222f' : '#e8edf3',
        border: isDark ? '1px solid #233142' : 'none',
        whiteSpace: 'nowrap'
      }}
    >
      {tabs.map(tab => {
        const isActive = filterTab === tab.id || (tab.id === 'resueltos' && filterTab === 'cerrados');
        const isEnProgreso = tab.id === 'en_progreso';
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => setFilterTab(tab.id)}
            title={tab.title || tab.label}
            className={`btn btn-sm d-inline-flex align-items-center justify-content-center gap-1.5 rounded-3 border-0 py-1.5 text-nowrap transition-base shadow-none ${isMobile ? 'flex-fill px-2' : 'px-2.5'
              }`}
            style={{
              fontSize: '0.80rem',
              fontWeight: isActive ? 700 : 500,
              backgroundColor: isActive
                ? (isDark ? '#1e293b' : '#ffffff')
                : 'transparent',
              color: isActive
                ? (isDark ? '#f8fafc' : '#0f172a')
                : (isDark ? '#94a3b8' : '#64748b'),
              boxShadow: isActive
                ? (isDark ? '0 1px 3px rgba(0,0,0,0.3)' : '0 1px 3px rgba(0,0,0,0.08)')
                : 'none',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            <span>{tab.label}</span>
            <span
              className="rounded-pill d-inline-flex align-items-center justify-content-center flex-shrink-0 px-2"
              style={{
                height: '19px',
                minWidth: '22px',
                fontSize: '0.70rem',
                fontWeight: 600,
                backgroundColor: isActive
                  ? (isDark ? 'rgba(56, 189, 248, 0.18)' : '#e0f2fe')
                  : (isDark ? 'rgba(255, 255, 255, 0.08)' : '#e2e8f0'),
                color: isActive
                  ? (isDark ? '#38bdf8' : '#0284c7')
                  : (isDark ? '#94a3b8' : '#64748b'),
                transition: 'all 0.15s ease'
              }}
            >
              {tab.count ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default TicketsFilterTabs;